import React, { FC } from "react";
import { IFormItem } from "../Types";
import { Button, Form, Upload } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import { importPropsConfig } from "@src/utils/importFile";
import FontIcon from "@src/components/YhIcon";
import { getBaseRequestUrl, getToken } from "@src/utils/constants";

export const __FormUpload: FC<IFormItem> = (props) => {
    return (
        <Form.Item
            label={props.fieldLabel}
            name={props.fieldName}
            rules={props.rules}
            labelCol={props.labelCol}
        >
            <Upload
                {...importPropsConfig(props.uploadUrl, props?.onUploadSuccess)}
                name={props.fileName ?? 'fileName'}
                defaultFileList={props.defaultFileList}
                fileList={props.fileList}
                showUploadList={{
                    // showDownloadIcon: true,
                    showPreviewIcon: false,
                    // downloadIcon: () => 'download',
                }}
                // onDownload={(e) => { console.log(e); debugger }}
                onPreview={(e) => { window.open(`${getBaseRequestUrl()}/oa/notice/downloadAttach?Authorization=${getToken()}&id=${e.response.retData}`) }}
                iconRender={(file) => {
                    if (file.type.indexOf('image/') !== -1) return <FontIcon style={{ fontSize: '24px' }} type="icon-tupian2" />
                    if (file.type === '.pdf') return <FontIcon style={{ fontSize: '24px' }} type="icon-pdf" />
                }}
            >
                <Button icon={<UploadOutlined />}>选择文件上传</Button>
            </Upload>
        </Form.Item>
    )
}